<template>
  <v-card color="accent" class="mb-3">
    <v-card-actions>
      <v-row>
        <v-col cols="4">
          <v-btn block color="light" text to="/me">
            <v-icon>
              mdi-account-circle
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn block color="light" text to="/my-articles">
            <v-icon>
              mdi-text-box-multiple-outline
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn block color="light" text @click="songDialog = true">
            <v-icon>
              mdi-music
            </v-icon>
          </v-btn>
          <DialogSongs :dialog="songDialog" @closeDialog="closeDialog" />
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import DialogSongs from "./DialogSongs.vue"
import projectMixin from "@/mixins/projectMixin"

export default {
  name: "WidgetDashboardQuickButtons",
  mixins: [projectMixin],
  components: {
    DialogSongs,
  },
  data() {
    return {
      article_stats: {},
      project: [],
      songDialog: false,
    }
  },
  methods: {
    closeDialog() {
      this.songDialog = false
    },
  },
}
</script>
